import { IIconProps } from '../../types/IconProps.interface'

export const IconError = ({ color = 'white', className }: IIconProps) => {
  return (
    <svg
      className={`w-full ${className}`}
      fill='none'
      viewBox='0 0 16 16'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_41029_182003)'>
        <path
          d='M8 0.5C12.1421 0.5 15.5 3.85786 15.5 8C15.5 12.1421 12.1421 15.5 8 15.5C3.85786 15.5 0.5 12.1421 0.5 8C0.5 3.85786 3.85786 0.5 8 0.5ZM8 10.25C7.58579 10.25 7.25 10.5858 7.25 11C7.25 11.4142 7.58579 11.75 8 11.75H8.00781C8.422 11.75 8.75781 11.4142 8.75781 11C8.75781 10.5858 8.422 10.25 8.00781 10.25H8ZM8 4.25C7.58579 4.25001 7.25 4.58579 7.25 5V8C7.25 8.41421 7.58579 8.74999 8 8.75C8.41421 8.75 8.75 8.41421 8.75 8V5C8.75 4.58579 8.41421 4.25 8 4.25Z'
          fill={color}
        />
      </g>
      <defs>
        <clipPath id='clip0_41029_182003'>
          <rect fill='white' height='16' width='16' />
        </clipPath>
      </defs>
    </svg>
  )
}
